<template>
	<li v-if="isVisible">
		<div
			v-if="isMenu"
			class="nav-link sidebar-menu-item"
			:aria-expanded="!collapsed"
			data-toggle="collapse"
			@click.prevent="collapseMenu"
		>
			<i class="fa" style="font-size:1.286rem !important;" :class="link.icon"></i>
			<p class="link_name">
				{{ link.name }}
				<i class="fa fa-caret-down caret_icon" aria-hidden="true"></i>
			</p>
		</div>

		<collapse-transition>
			<div v-if="$slots.default || this.isMenu" v-show="!collapsed">
				<ul class="nav">
					<slot></slot>
				</ul>
			</div>
		</collapse-transition>
		<slot name="title" v-if="!this.isMenu && !$slots.default && link.path">
			<component v-if="!(locked && isTrackAndPay)"
					   :to="fullLinkPath(link)"
					   @click.stop="linkClick(link)"
					   :is="elementType(link, false)"
					   :class="{ active: isActive, locked: locked }"
					   class="nav-link"
					   :target="link.target"
			>
				<el-tooltip placement="right" :open-delay="750" :disabled="!locked">
					<span slot="content" v-html="lockedTooltip"></span>
					<div v-if="addLink">
            <span class="sidebar-mini">
              {{ linkAbbreviation(link) }}
            </span>
						<span class="sidebar-normal">
              {{ link.name }}
              <i v-if="locked" class="lock_icon fa fa-lock"></i>
            </span>
					</div>
					<div v-else>
						<i :class="link.icon" style="font-size:1.286rem !important;"></i>
						<p class="link_name">{{ link.name }}</p>
					</div>
				</el-tooltip>
			</component>
		</slot>
	</li>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import {accessDeniedTooltip, hasAccess, hasRequiredTraderType} from "@/common/permission/permission";
import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
	components: {
		CollapseTransition
	},
	props: {
		link: { type: Object },
	},
	provide() {
		return {
			addLink: this.addChild,
			removeLink: this.removeChild
		};
	},
	inject: {
		addLink: { default: null },
		removeLink: { default: null },
		autoClose: { default: true }
	},
	data() {
		return {
			children: [],
			collapsed: true
		};
	},
	computed: {
		isMenu() {
			return this.children.length > 0;
		},
		isActive() {
			// force active based on item flag if present
			if (this.link.active !== undefined) {
				return this.link.active;
			}

			// otherwise automatically set active based on current route
			if (this.$route && this.$route.path) {
				let matchingRoute = this.children.find(c =>
					this.$route.path.startsWith(c.link.path)
				);
				if (matchingRoute) {
					this.collapsed = false;
				}
				if (matchingRoute !== undefined) {
					return true;
				}
			}
			return false;
		},
		locked() {
			return this.link.permissions
				? !this.link.permissions.some(permission => hasAccess(this.currentUser, permission))
				: false;
		},
		lockedTooltip() {
			return this.link.permissions
				? accessDeniedTooltip(this.currentUser, this.link.permissions[0])
				: "";
		},
		isVisible() {
			return hasRequiredTraderType(this.currentUser, this.link.onlyVisibleFor);
		},
		shouldBeExpandedByDefault() {
			return hasRequiredTraderType(this.currentUser, this.link.expandedByDefaultFor, false);
		},
		isTrackAndPay() {
			return this.link.path === navigationPaths.seller.trackPay || this.link.path === navigationPaths.debtor.trackPay;
		}
	},
	methods: {
		addChild(item) {
			const index = this.$slots.default.indexOf(item.$vnode);
			this.children.splice(index, 0, item);
		},
		removeChild(item) {
			const tabs = this.children;
			const index = tabs.indexOf(item);
			tabs.splice(index, 1);
		},
		elementType(link, isParent = true) {
			if (link.disabled || this.locked || isParent) {
				return "li";
			} else {
				return "router-link";
			}
		},
		fullLinkPath(link) {
			let fullPath = link.path;

			Object.keys(link.query || {})
				.forEach((key, index) => {
					fullPath += ((index === 0) ? "?" : "&") + key + "=" + link.query[key];
				});

			return fullPath;
		},
		linkAbbreviation(link) {
			if (link.abbreviation) {
				return link.abbreviation;
			}

			let regExp = /(?:^(\S))|(?:[\s-](\S))/g;
			var abbreviation = "";

			var match = null;
			var groupIndex = 0; // start with 1, since index = 0 is the matched text
			while (match = regExp.exec(link.name)) {
				abbreviation += match[groupIndex].toUpperCase()
					.trim();
			}

			return abbreviation.replace("&", "n");
		},
		linkClick(item) {
			if (item.disabled || this.locked) {
				return;
			}
			if (
				this.autoClose &&
				this.$sidebar &&
				this.$sidebar.showSidebar === true
			) {
				this.$sidebar.displaySidebar(false);
			}
		},
		collapseMenu() {
			this.collapsed = !this.collapsed;
		},
	},
	mounted() {
		if (this.addLink) {
			this.addLink(this);
		}
		if (this.link.collapsed !== undefined) {
			this.collapsed = this.link.collapsed;
		}

		if (this.isMenu && (this.isActive || this.shouldBeExpandedByDefault)) {
			this.collapsed = false;
		}
	},
	destroyed() {
		if (this.$el && this.$el.parentNode) {
			this.$el.parentNode.removeChild(this.$el);
		}
		if (this.removeLink) {
			this.removeLink(this);
		}
	},
};
</script>
<style lang="scss" scoped>
.sidebar-menu-item {
	cursor: pointer;
}

.nav {
	li {
		position: relative;
	}
}

.lock_icon {
	float: none !important;
	height: auto !important;
}
</style>
